import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LogoBlue from './img/logo_sotec_b.png'
import CallBlack from './img/icon_btn_call_b.png'
import Recruitment from './img/recruitment.png'
import './css/Header_White.css'

function HeaderBase({ onHover, onHoverEnd, isWhiteBack }) {
    const menuRef = useRef(null);
    const [menuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        // console.log('하얀색 배경 적용 => ' + isWhiteBack);
        var head = document.getElementById('menu_w');
        var big_category = document.getElementsByClassName('big_category_w')[0];
        var hambMenu = document.getElementsByClassName('menu_hamb_container')[0];

        if (hambMenu.classList.contains('hambMenu_transpar')) {
            hambMenu.classList.remove('hambMenu_transpar');
        }

        if (big_category.classList.contains('category_transpar')) {
            big_category.classList.remove('category_transpar')
        }

        if (typeof isWhiteBack != 'undefined') {
            // 메인화면의 동작
            if (!isWhiteBack && menuOpen) {
                // 투명헤더에서 창을 열었을때
                head.style.backgroundColor = '#fff';
                big_category.style.color = 'red';
                // console.log('배경 적용 1번 ' + isWhiteBack + '/' + menuOpen);
            } else if (!isWhiteBack && !menuOpen) {
                // 투명헤더로 보여야 할때
                head.style.backgroundColor = '#0c4da20d';
                big_category.style.color = '#fff';
                hambMenu.classList.add('hambMenu_transpar');
                big_category.classList.add('category_transpar')
                // console.log('배경 적용 2번 ' + isWhiteBack + '/' + menuOpen);
            }
            else {
                // 하얀색 헤더일때 열고 닫을때
                head.style.backgroundColor = '#fff';
                big_category.style.color = 'red';
                // console.log('배경 적용 3번 ' + isWhiteBack + '/' + menuOpen);
            }
        } else {
            // 메뉴 선택 시 iswhiteBack이 undefined로 잡힘.
            head.style.backgroundColor = '#fff';
            big_category.style.color = '#000';
            // console.log('배경 적용 4번 ' + isWhiteBack + '/' + menuOpen);
        }
    });


    const handleHover = () => {
        const menuHeight = menuRef.current ? menuRef.current.clientHeight : 0; // 메뉴의 높이
        const windowHeight = window.innerHeight; // 전체 화면의 높이
        const remainingHeight = windowHeight - menuHeight;
        setIsMenuOpen(true);
        onHover(remainingHeight);

        // var head = document.getElementById('menu_w');
        // head.style.backgroundColor = '#fff';

    };

    const handleHoverEnd = () => {
        if (onHoverEnd) {
            setIsMenuOpen(false);
            onHoverEnd(); // 호버가 끝났을 때 부모 컴포넌트에 알림

            // var head = document.getElementById('menu_w');

            // if (!isWhiteBack) {
            //     console.log("헤더 닫음_1");
            //     head.style.backgroundColor = '#0c4da20d';
            // } else {
            //     console.log("헤더 닫음_2");
            //     head.style.backgroundColor = '#fff';
            // }
        }
    };

    const logoClick = () => {
        var head = document.getElementById('menu_w');
        var menuBox = document.getElementById('Menu_Box_Container');

        if (head.classList.contains('header_menu_open')) {
            head.classList.remove('header_menu_open')
            menuBox.classList.remove('Menu_Box_Container_open')
            document.body.style.overflow = 'auto';

            var menuBlind = document.getElementById('Menu_blind');
            head.removeChild(menuBlind);
            onHoverEnd();
        }

    }

    const hambClick = () => {
        var head = document.getElementById('menu_w');
        var menuBox = document.getElementById('Menu_Box_Container');

        if (head.classList.contains('header_menu_open')) {
            head.classList.remove('header_menu_open')
            menuBox.classList.remove('Menu_Box_Container_open')
            document.body.style.overflow = 'auto';

            var menuBlind = document.getElementById('Menu_blind');
            head.removeChild(menuBlind);

            onHoverEnd();
        } else {
            head.classList.add('header_menu_open')
            menuBox.classList.add('Menu_Box_Container_open')
            document.body.style.overflow = 'hidden';

            var bliDiv = document.createElement('div');
            bliDiv.id = 'Menu_blind';
            head.appendChild(bliDiv);

        }
    }

    const hamItemClick = (event) => {
        hambClick();
    }


    return (
        <div id="menu_w" className='menu_w' ref={menuRef} style={{ width: '100%' }}>
            <div className='logo_w'>
                <Link to="/" onClick={logoClick}>
                    <img className='logo_img' src={LogoBlue}></img>
                </Link>
            </div>
            <ul className='big_category_w' onMouseOver={handleHover} onMouseLeave={handleHoverEnd}>
                {/* <li className='logo_w' style={{width:'20%'}}>
                       
                        <Link to="/">
                            <img src={LogoBlue}></img>
                        </Link>
                      
                    </li> */}
                <li className='category_w' ><li>회사소개</li>
                    <ul className='small_category_w'>
                        <Link to="/CEOInst"><li style={{ marginTop: '25px' }}>CEO 인사말</li></Link>
                        <Link to="/Vision"><li>경영 비전</li></Link>
                        <Link to="/CompHistory"><li>회사연혁</li></Link>
                        {/* <Link to="/FileUpload"><li>회사연혁222</li></Link> */}
                    </ul>
                </li>
                <li className='category_w' ><li>사업분야</li>
                    <ul className='small_category_w'>
                        <Link to="/Building" state={{data : 'B'}}><li>설계</li></Link>
                        <Link to="/Building" state={{data : 'I'}}><li>시스템 개발</li></Link>
                        <Link to="/Building" state={{data : 'Q'}}><li>품질 검사</li></Link>
                        <Link to="/Building" state={{data : 'V'}}><li>VR 교육 솔루션</li></Link>
                    </ul>
                </li>
                <li className='category_w' ><li>홍보센터</li>
                    <ul className='small_category_w'>
                        <Link to="/News"><li style={{ marginTop: '25px' }}>보도자료</li></Link>
                        <Link to="/CompanyMagazine"><li>쏘테크 메거진</li></Link>
                        {/* <Link to="/Gallery"><li>포토 갤러리</li></Link> */}
                    </ul>
                </li>
                <li className='category_w'><div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}><img src={Recruitment} /><div style={{ lineHeight: '15px' }}>인재채용</div></div>
                    <ul className='small_category_w'>
                        <Link to="/RecruitmentCard"><li style={{ marginTop: '50px' }}>채용공고</li></Link>
                        <Link to="/JobIntroduction"><li >직무소개</li></Link>
                        <Link to="/PersonnelSystem"><li >인사제도</li></Link>
                        <Link to="/CultivateHR"><li >인재상</li></Link>
                    </ul>
                </li>
                <li className='category_w'><li>고객지원</li>
                    <ul className='small_category_w'>
                        <Link to="/ESGManagement"><li style={{ marginTop: '25px' }}>ESG경영</li></Link>
                        <Link to="/Location"><li>찾아오시는 길</li></Link>
                        <Link to="/FAQ"><li>자주하는 질문</li></Link>
                    </ul>
                </li>
                {/* <li className='category_w' style={{ width: '20%', display: 'flex', justifyContent: 'center', height: '79px' }}>
                </li> */}
            </ul>

            <div className="menu_hamb_container" onClick={hambClick}>
                <button type="button" class="hamb_btn">
                </button>
            </div>

            <div id='Menu_Box_Container'>


                {/* <ul className='big_category_w2' >

                    <li><li onClick={hamItemClick}>회사소개</li>
                        <ul>
                            <Link to="/CEOInst"><li onClick={hamItemClick}>CEO 인사말</li></Link>
                            <Link to="/Vision"><li onClick={hamItemClick}>경영 비전</li></Link>
                            <Link to="/CompHistory"><li onClick={hamItemClick}>회사연혁</li></Link>
                        </ul>
                    </li>

                </ul> */}


                <ul class="Menu_accordion">
                    <li>
                        <input type="checkbox" id="item1" hidden />
                        <label for="item1">회사소개</label>
                        <div class="accordion-content">
                            <ul>
                                <Link to="/CEOInst"><li onClick={hamItemClick}>CEO 인사말</li></Link>
                                <Link to="/Vision"><li onClick={hamItemClick}>경영 비전</li></Link>
                                <Link to="/CompHistory"><li onClick={hamItemClick}>회사연혁</li></Link>
                            </ul>
                        </div>
                    </li>

                    <li>
                        <input type="checkbox" id="item2" hidden />
                        <label for="item2">사업분야</label>
                        <div class="accordion-content">
                            <ul>
                                <Link to="/Building" state={{data : 'B'}}><li onClick={hamItemClick}>설계</li></Link>
                                <Link to="/Building" state={{data : 'I'}}><li onClick={hamItemClick}>시스템 개발</li></Link>
                                <Link to="/Building" state={{data : 'Q'}}><li onClick={hamItemClick}>품질 검사</li></Link>
                                <Link to="/Building" state={{data : 'V'}}><li onClick={hamItemClick}>VR 교육 솔루션</li></Link>
                            </ul>
                        </div>
                    </li>

                    <li>
                        <input type="checkbox" id="item3" hidden />
                        <label for="item3">홍보센터</label>
                        <div class="accordion-content">
                            <ul>
                                <Link to="/News"><li onClick={hamItemClick}>보도자료</li></Link>
                                <Link to="/CompanyMagazine"><li onClick={hamItemClick}>쏘테크 메거진</li></Link>
                            </ul>
                        </div>
                    </li>

                    <li>
                        <input type="checkbox" id="item4" hidden />
                        <label for="item4">인재채용</label>
                        <div class="accordion-content">
                            <ul>
                                                      <Link to="/RecruitmentCard"><li onClick={hamItemClick}>채용공고<span style={{
                                    backgroundColor: '#0c4da2', borderRadius: '8px'
                                    , fontSize: '12px', padding: '3px 10px'
                                    , color: 'white', marginLeft: '7px'
                                }}>채용 진행중</span></li></Link>
                                <Link to="/JobIntroduction"><li onClick={hamItemClick}>직무소개</li></Link>
                                <Link to="/PersonnelSystem"><li onClick={hamItemClick}>인사제도</li></Link>
                                <Link to="/CultivateHR"><li onClick={hamItemClick}>인재상</li></Link>
                            </ul>
                        </div>
                    </li>

                    <li>
                        <input type="checkbox" id="item5" hidden />
                        <label for="item5">고객지원</label>
                        <div class="accordion-content">
                            <ul>
                                <Link to="/ESGManagement"><li onClick={hamItemClick}>ESG경영</li></Link>
                                <Link to="/Location"><li onClick={hamItemClick}>찾아오시는 길</li></Link>
                                <Link to="/FAQ"><li onClick={hamItemClick}>자주하는 질문</li></Link>
                            </ul>
                        </div>
                    </li>
                </ul>



            </div>




        </div >

    );
}

export default HeaderBase;